export const iconFontAwesomeDesignRulerHorizontal = (
	<i className="fa-solid fa-ruler-horizontal"></i>
);
